"use client";

import { useQuery } from "@tanstack/react-query";
import { hotelSearchAction } from "@/actions/hotel.action";
import type { HotelSearchResponse } from "@/types/api";

type UseHotelNameSuggestionsParams = {
  search: string;
  start: string;
  end: string;
  adults: number;
  children: number;
  rooms: number;
  enabled?: boolean;
  limit?: number;
};

/**
 * Fetch hotel-name suggestions for Hotels search form.
 */
export const useHotelNameSuggestions = ({
  search,
  start,
  end,
  adults,
  children,
  rooms,
  enabled = true,
  limit = 8,
}: UseHotelNameSuggestionsParams) => {
  return useQuery<HotelSearchResponse, Error>({
    queryKey: [
      "hotel-name-suggestions",
      search,
      start,
      end,
      adults,
      children,
      rooms,
      limit,
    ],
    queryFn: () =>
      hotelSearchAction({
        adults,
        children,
        room: rooms,
        start,
        end,
        type: "popular",
        search,
        limit,
      }),
    enabled,
  });
};
